define('common/ko/fn/orElse',['knockout'], function(ko) {

    /**
     * A simpler alternative to withFallback for more general use.
     *
     * @param {any} fallbackValue
     *
     * @return {Subscribable}
     */
    ko.subscribable.fn.orElse = function(fallbackValue) {

        var factory = this.map ? ko.pureComputedArray : ko.pureComputed;

        return factory({
            owner: this,
            read: function() {

                var value = this();

                if (value === undefined || value === null) {
                    return ko.unwrap(fallbackValue);
                }

                return value;

            },
            write: this
        });

    };

});

